<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="examStreamForm ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">
                <div *ngIf="submitButton">
                    <h4 class="main-content-label mb-1"><b>Add New Branch/Stream Record</b></h4>
                </div>
                <div *ngIf="editButton">
                    <h4 class="main-content-label mb-1"><b>Update Branch/Stream Record</b></h4>
                </div>
                <div *ngIf="deleteButton">
                    <h4 class="main-content-label mb-1"><b>Delete Branch/Stream Record</b></h4>
                </div>

                <div class="row clearfix">
                    <div class="col-sm-4">
                        <div class="form-group">
                            <mat-form-field appearance="outline" class="example-full-width">
                                <mat-label>Course Name</mat-label>
                                <input readonly style="color:black;" matInput formControlName="courseName"
                                    placeholder="" required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Code</mat-label>
                            <input appUppercase [readonly]="updateReadOnly || deleateReadOnly" style="color:black;" matInput
                                formControlName="StrCode" placeholder="Stream Code" maxlength="5" required>
                            <mat-error class="margin_tp"
                                *ngIf="examStreamForm.controls['StrCode'].touched && examStreamForm.controls['StrCode'].errors?.required">
                                Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                                *ngIf="examStreamForm.controls['StrCode'].touched && examStreamForm.controls['StrCode'].errors?.pattern">
                                Invalid
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-3 hidden">
                        <div class="row">
                            <div class="col-sm-4 mt-2 mr-0">
                                <mat-label class=" lclass "><span
                                        class="required-asterisk mr-1"></span>Active</mat-label>
                            </div>
                            <div class="col-sm-8">
                                <mat-radio-group [disabled]="deleateReadOnly" formControlName="StrActive"
                                    class="example-full-width">
                                    <div class="row">
                                        <div class="col-sm-6 mt-2">
                                            <mat-radio-button value='Y'>Yes</mat-radio-button>
                                        </div>
                                        <div class="col-sm-5 mt-2">
                                            <mat-radio-button value='N'>No</mat-radio-button>
                                        </div>
                                    </div>
                                </mat-radio-group>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Roll No Prefix </mat-label>
                            <input [readonly]="deleateReadOnly" style="color:black;" matInput
                                formControlName="StrSpFlag" placeholder="Roll No Prefix " maxlength="5" required>
                            <mat-error class="margin_tp"
                                *ngIf="examStreamForm.controls['StrSpFlag'].touched && examStreamForm.controls['StrSpFlag'].errors?.required">
                                Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                                *ngIf="examStreamForm.controls['StrSpFlag'].touched && examStreamForm.controls['StrSpFlag'].errors?.pattern">
                                Invalid
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-4">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Name</mat-label>
                            <input appCamelcase [readonly]="deleateReadOnly" style="color:black;" maxlength="60" matInput
                                formControlName="StrName" placeholder="Name" required>
                            <mat-error class="margin_tp"
                                *ngIf="examStreamForm.controls['StrName'].touched && examStreamForm.controls['StrName'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-2">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Pass Credits </mat-label> 
                            <input [readonly]="deleateReadOnly" style="color:black;" matInput
                                formControlName="StrPassCr" maxlength="7" step="0.01" placeholder="eg 90.00 or 90"
                                required>
                            <mat-error class="margin_tp"
                                *ngIf="examStreamForm.controls['StrPassCr'].touched && examStreamForm.controls['StrPassCr'].errors?.required">
                                Mandatory
                            </mat-error>
                            <mat-error class="margin_tp"
                                *ngIf="examStreamForm.controls['StrPassCr'].touched && examStreamForm.controls['StrPassCr'].errors?.pattern">
                                Invalid
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 row ">
                        <div class="col-sm-12 prpl">
                            <button id="Delete" *ngIf="deleteButton && CourseBranchDelete" type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                                (click)="openConformationModalBox()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/trash.gif" style="margin-right: 5px;">
                                    Delete
                                </span>
                            </button>
                            <button id="Update" *ngIf="editButton && CourseBranchUpdate" type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                                (click)="update()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/edit1.gif" style="margin-right: 5px;">
                                    Update
                                </span>
                            </button>
                            <button id="Save"  *ngIf="submitButton && CourseBranchCreate" type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                                (click)="submit()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                    Save
                                </span>
                            </button>
                            <button id="Back" (click)="back()" type="button"
                            class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                            <span style="display: contents; align-items: center;">
                                <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                Back
                            </span>
                        </button>
                        </div>
                    </div>
                    
                </div>
                <hr *ngIf="isDivShow==true">
                <div *ngIf="isDivShow==true">
                    <span class="main-content-label"><b>Branch/Stream List</b></span>
                    <!-- <span> List</span> -->
                    <p class="text-muted card-sub-title mb-0">
                        Branch/Stream Data</p>
                </div>
                <hr *ngIf="isDivShow==true">

                <div *ngIf="isDivShow==true" class="table-responsive">
                    <table id="dtBasicExample" class="table table-bordered text-nowrap ">
                        <thead>
                            <tr>
                                <th class="f600">
                                    Id
                                </th>
                                <th class="f600">
                                    Code
                                </th>
                                <th class="f600">
                                    Stream
                                </th>
                                <th class="f600">
                                    Active
                                </th>
                                <th class="f600">
                                    Roll No Prefix
                                </th>
                                <th class="f600">
                                    Pass Credits
                                </th>
                                <th class="f600 text-center">
                                    Action </th>
                            </tr>
                        </thead>
                        <tbody id="table_data">
                            <tr *ngFor="let exStream of exStreamList;">
                                <td> {{exStream.StrId}} </td>
                                <td> {{exStream.StrCode}} </td>
                                <td> {{exStream.StrName}} </td>
                                <td> {{exStream.StrActive}} </td>
                                <td> {{exStream.StrSpFlag}} </td>
                                <td> {{exStream.StrPassCr}} </td>
                                <td class="text-center">
                                    <a class="btn-floating" title="Edit" (click)="editdata('true',exStream)">
                                        <i class="fa fa-edit"></i>
                                    </a>
                                    <a class="btn-floating" title="Delete" (click)="deletee('true',exStream)">
                                        <i class="fas fa-trash"></i>
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>
    </form>
</div>